/* eslint-disable react/require-default-props */
import React, { useCallback, useState, useEffect } from 'react';
import classNames from 'classnames';
import { Light as SyntaxHighlighterBase } from 'react-syntax-highlighter';
import sql from 'react-syntax-highlighter/dist/esm/languages/prism/sql';
import json from 'react-syntax-highlighter/dist/esm/languages/prism/json';
import ruby from 'react-syntax-highlighter/dist/esm/languages/prism/ruby';
import javascript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript';
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python';
import { vs } from 'react-syntax-highlighter/dist/esm/styles/prism';
import './CodeBlockStyles.scss';
// Cast to work around React 18 types incompatibility with react-syntax-highlighter@15
const SyntaxHighlighter = SyntaxHighlighterBase;
// Track if languages have been registered to avoid duplicate registration
let languagesRegistered = false;
// Register languages safely
const registerLanguages = () => {
    if (languagesRegistered)
        return;
    try {
        if (typeof SyntaxHighlighter.registerLanguage === 'function') {
            SyntaxHighlighter.registerLanguage('sql', sql);
            SyntaxHighlighter.registerLanguage('json', json);
            SyntaxHighlighter.registerLanguage('ruby', ruby);
            SyntaxHighlighter.registerLanguage('javascript', javascript);
            SyntaxHighlighter.registerLanguage('python', python);
            languagesRegistered = true;
        }
    }
    catch (error) {
        // Silently fail in environments where registration isn't supported
        console.warn('Could not register syntax highlighter languages:', error);
    }
};
const baseClass = 'qmb-ui-code-block';
/**
 * CodeBlock Component
 * Renders a fenced code block with syntax highlighting and a copy button.
 * Uses react-syntax-highlighter/prism-async-light with only required languages.
 * @version 1.0.0
 * @since 2026-02-18
 */
export function CodeBlock({ children, language = 'text', className }) {
    const [copied, setCopied] = useState(false);
    // Register languages on mount
    useEffect(() => {
        registerLanguages();
    }, []);
    const handleCopy = useCallback(() => {
        void navigator.clipboard.writeText(children).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    }, [children]);
    return (React.createElement("div", { className: classNames(baseClass, className) },
        React.createElement("div", { className: `${baseClass}__header` },
            React.createElement("span", { className: `${baseClass}__language` }, language),
            React.createElement("button", { type: "button", className: classNames(`${baseClass}__copy`, { [`${baseClass}__copy--copied`]: copied }), onClick: handleCopy, "aria-label": copied ? 'Copied' : 'Copy code' },
                React.createElement("i", { className: classNames('fa-light', copied ? 'fa-check' : 'fa-copy') }),
                React.createElement("span", null, copied ? 'Copied' : 'Copy'))),
        React.createElement(SyntaxHighlighter, { language: language, style: vs, customStyle: { margin: 0, padding: '12px', fontSize: '1.3rem' }, wrapLongLines: true }, children)));
}
